import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <div className="cinematic-container min-h-screen">
      <div className="text-center max-w-2xl mx-auto px-6 cinematic-fade-in">
        <h1 className="text-display font-display text-primary mb-6 tracking-tight">
          404
        </h1>
        <p className="text-xl text-foreground/70 mb-12 leading-relaxed">
          Not everything is meant to be found.
        </p>
        <Link
          to="/"
          className="inline-block px-8 py-4 border border-primary/30 text-primary hover:bg-primary/10 transition-all duration-1500 ease-cinematic"
        >
          Return Home
        </Link>
      </div>
    </div>
  )
}
